// Get substring between character(s)

'use strict';

export default function getSubstringBetween(string, start, end) {
    var substring = string.indexOf(start) + start.length;
    return string.substring(substring, string.indexOf(end, substring));
}